import React, { useState, useEffect } from 'react'
import ExamHeadHeader from '../common/ExamHeadHeader'
import Footer from '../common/Footer'
import { baseUrl } from '../../Utility/constants'
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { MarksFeedingEndpoints } from '../../Utility/Endpoints';

const ApproveEditMarks = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await axios.get(MarksFeedingEndpoints.ExamHeadEditMarksNotification);
            setData(response.data || []);
        } catch (error) {
            toast.error("Error fetching data");
        }
    };

    const ApproveRequest = async (marksFeedingId) => {
        if (window.confirm("Are you sure to approve this request?")) {
            try {
                const res = await axios.put(`${MarksFeedingEndpoints.ApproveEditMarksRequest}?id=${marksFeedingId}`);
                if (res.status === 200 && res.data) {
                    toast.success(res.data?.message);
                    fetchData(); // Refresh list after approval
                } else {
                    toast.error("Failed to approve the request.");
                }
            } catch (error) {
                toast.error("Failed to approve request");
            }
        }
    };

    return (
        <>
            <ExamHeadHeader />
            <div className="container mt-5 mb-5">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4>Approve Edit Marks Request</h4>
                </div>

                <table className="table table-bordered table-striped">
                    <thead className="table-dark">
                        <tr>
                            <th>#</th>
                            <th>Student Name</th>
                            <th>GR No</th>
                            <th>Roll No</th>
                            <th>Standard</th>
                            <th>Section</th>
                            <th>Stream</th>
                            <th>Subject Group</th>
                            <th>Marks Obtained</th>
                            <th>Mark Status</th>
                            <th>Exam Mark Type</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length ? data.map((item, i) => (
                            <tr key={item.marksFeedingId}>
                                <td>{i + 1}</td>
                                <td>{`${item.firstName} ${item.middleName} ${item.lastName}`}</td>
                                <td>{item.generalRegisterNo}</td>
                                <td>{item.rollNo}</td>
                                <td>{item.standardName}</td>
                                <td>{item.sectionName}</td>
                                <td>{item.streamName}</td>
                                <td>{item.subjectGroup}</td>
                                <td>{item.marksObtained}</td>
                                <td>{item.markStatus}</td>
                                <td>{item.examMarkType}</td>
                                <td>
                                    <button
                                        className="btn btn-warning btn-sm me-2"
                                        onClick={() => ApproveRequest(item.marksFeedingId)}
                                    >
                                        Approve
                                    </button>
                                </td>
                            </tr>
                        )) : <tr><td colSpan="12" className="text-center">No records found</td></tr>}
                    </tbody>
                </table>
            </div>
            <ToastContainer position="top-right" autoClose={3000} />
            <Footer />
        </>
    )
}

export default ApproveEditMarks
